// Room & cottage listings — edit freely (CMS-ready)
const MYST = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/lpt3vik3_misty%20wood%202.jfif";
const PARIJATA = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/79v5li7i_parijaata%20cottege.jfif";
const PRAKRUTHI = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/3v42y3h1_prakruthi%20primium.jfif";
const COUPLE = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/kzhrtnkg_couple%20cottage.jfif";
const KADAMBA = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/vh9496jz_kadamba%20cottage.jfif";
const KING = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/l09vod0k_king%20glass%20cottege.jfif";
const ROYAL = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/mm8hni3b_royal%20glassccottege.jfif";
const DORM = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/b2he7sxw_doormetry.jfif";
const MOONLIGHT = "https://customer-assets-39nsmqrw.emergentagent.net/job_ghats-luxury/artifacts/aswja49f_tent%20house.jfif";

export const ROOMS = [
  {
    slug: "myst-wood-cottage",
    name: "Myst Wood Cottage",
    tagline: "Timber-warm A-frame wrapped in forest mist",
    highlight: "Guest Favourite",
    capacity: "Couples & Families",
    bed: "1 King Bed",
    image: MYST,
    gallery: [MYST, PARIJATA, PRAKRUTHI],
    description:
      "Our signature wooden cottage, panelled entirely in warm local timber and topped with slate. Cosy, romantic and wrapped in forest mist — a hideaway that families adore just as much as couples.",
    amenities: ["Air-conditioned room", "King bed", "Rain shower", "Filter coffee kit", "Cosy timber interiors", "Daily housekeeping"],
  },
  {
    slug: "king-glass-cottage-two",
    name: "King Glass Cottege",
    tagline: "A stunning glass house for four, under the canopy",
    highlight: "Glass House",
    capacity: "4 Sharing · Families & Friends",
    bed: "2 Beds · Air-Conditioned",
    image: KING,
    gallery: [KING, PARIJATA, MYST],
    description:
      "Step into pure Vruksha magic — a breathtaking glass-walled cottage where the entire forest becomes your view. Comfortably sleeping four across two beds with full air-conditioning, King Glass Cottege is where floor-to-ceiling glass, soft light and the misty Western Ghats blur the line between inside and out. Perfect for families and small groups who want that dreamy glass-house stay.",
    amenities: ["Floor-to-ceiling glass walls", "Sleeps 4 · 2 beds", "Air-conditioning", "Panoramic forest views", "Rain shower", "Daily housekeeping"],
  },
  {
    slug: "parijatha-glass-cottage",
    name: "Parijatha Glass Cottage",
    tagline: "Sleep beneath a soaring glass A-frame",
    highlight: "Most Iconic",
    capacity: "Couples & Families",
    bed: "1 King Bed",
    image: PARIJATA,
    gallery: [PARIJATA, KING, MYST],
    description:
      "The crown jewel of Vruksha Valley — a dramatic glass A-frame with a soaring timber ceiling that opens the sky and the forest right into your room. Wake to mist drifting past the glass and fall asleep under a blanket of stars. An unforgettable, cinematic glass-house stay for couples celebrating something special and families craving a little magic.",
    amenities: ["Soaring glass A-frame", "King bed", "Elegant interiors", "Private sit-out", "Rain shower", "Mini refrigerator"],
  },
  {
    slug: "prakruthi-premium-cottage",
    name: "Prakruthi Premium Cottage",
    tagline: "Bright, airy luxury with a lofty roof",
    highlight: "Premium",
    capacity: "Families",
    bed: "1 King + Seating",
    image: PRAKRUTHI,
    gallery: [PRAKRUTHI, PARIJATA, MYST],
    description:
      "Our most spacious premium cottage — bright white interiors under a lofty tiled roof, a generous seating area and a proper work-and-relax corner. Thoughtfully finished for guests who want that extra touch of comfort.",
    amenities: ["Spacious high-roof room", "Lounge seating", "Air-conditioning", "Premium linens", "Room service", "Rain shower"],
  },
  {
    slug: "royal-glass-cottage",
    name: "Royal Glass Cottege",
    tagline: "An intimate glass sanctuary built for two",
    highlight: "Glass House",
    capacity: "2 Sharing · Couples",
    bed: "1 Bed · Air-Conditioned",
    image: ROYAL,
    gallery: [ROYAL, PARIJATA, KING],
    description:
      "The most romantic glass house at Vruksha Valley. Designed for two, Royal Glass Cottege wraps you in glass on every side so the coffee estate and the misty ridgelines feel close enough to touch. Air-conditioned, beautifully styled and utterly private — the ultimate glass-house escape for couples and honeymooners.",
    amenities: ["Glass-walled sanctuary", "2 sharing · 1 bed", "Air-conditioning", "Private & romantic", "Rain shower", "Tea & coffee"],
  },
  {
    slug: "couple-cottage",
    name: "Couple Cottage",
    tagline: "A private nest tucked into the coffee plantation",
    highlight: "For Two",
    capacity: "Couples",
    bed: "1 Queen Bed",
    image: COUPLE,
    gallery: [COUPLE, MYST, KADAMBA],
    description:
      "A private cottage nestled deep in the coffee plantation with an attached bathroom. Wake up to the sound of birdsong and open your door to serene plantation views — intimate, quiet and made for two.",
    amenities: ["Private plantation setting", "Attached bathroom", "Queen bed", "Birdsong mornings", "Hot water", "Tea & coffee"],
  },
  {
    slug: "kadamba-cottage",
    name: "Kadamba Cottage",
    tagline: "Easy ground-floor comfort amid the greenery",
    highlight: "Ground Floor",
    capacity: "Families",
    bed: "1 King Bed",
    image: KADAMBA,
    gallery: [KADAMBA, COUPLE, PRAKRUTHI],
    description:
      "A comfortable ground-floor cottage, perfect for those who prefer easy, step-free access. Warm interiors open onto the gardens, with the forest always in view — relaxed and welcoming for the whole family.",
    amenities: ["Step-free ground floor", "King bed", "Garden access", "Rain shower", "Filter coffee", "Family friendly"],
  },
  {
    slug: "dormitory",
    name: "Grand Gathering Cottage",
    tagline: "Room for the whole gang to stay together",
    highlight: "For Groups",
    capacity: "Groups & Friends",
    bed: "Multiple Beds",
    image: DORM,
    gallery: [DORM, MYST, KADAMBA],
    description:
      "A spacious, comfortable shared cottage built for big groups and gangs of friends. Bunk down together after a day by the pool and a night around the bonfire — the most fun, sociable way to experience the valley as one big crew.",
    amenities: ["Sleeps a large group", "Shared clean washrooms", "Common lounge", "Great for groups", "Lockers", "Bonfire access"],
  },
  {
    slug: "moonlight-tents",
    name: "Moonlight Tents",
    tagline: "Sleep under the stars in our lakeside camping tents",
    highlight: "Camping",
    capacity: "Couples & Friends",
    bed: "Camping Tent",
    image: MOONLIGHT,
    gallery: [MOONLIGHT, MYST, DORM],
    description:
      "For the true explorers — spend a night in our lakeside Moonlight Tents and fall asleep beneath a canopy of stars. With the moon glowing over the treeline and the sounds of the forest all around, it is the most magical, back-to-nature way to experience Vruksha Valley. Perfect for couples and adventurous groups of friends.",
    amenities: ["Lakeside camping tents", "Star-lit nights", "Bonfire nearby", "Shared washrooms", "Great for friends", "Nature immersion"],
  },
];

export const getRoom = (slug) => ROOMS.find((r) => r.slug === slug);
